import React from 'react'

import Box from '../Box'

import { OverlayProps } from './Overlay.types'

const Overlay: React.FC<OverlayProps> = ({ zIndex = 9, ...props }) => {
  return (
    <Box
      backgroundColor='overlay75'
      width='100vw'
      height='100vh'
      position='fixed'
      top={0}
      left={0}
      zIndex={zIndex}
      {...props}
    />
  )
}

export default Overlay
export type { OverlayProps }
